import { useQuery } from "@tanstack/react-query";

import { fetchMapSectorsInfo } from "../../services/network/map_sector-api";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS} from "../../services/network/endpoints";

export function useFetchEvents() {
  const { data, error, isLoading } = useQuery({
    queryKey: [EVENT_ENDPOINTS.FETCH_EVENTS],
    queryFn: () => EventAPI.fetchEvents(),
    select: (response) => response.data?.map(role => role) || []
  });

  return {
    eventsData: data,
    eventsError: error,
    eventsIsLoading: isLoading,
  };
}
